import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { CheckCircleIcon } from '@heroicons/react/24/outline';
import AssessmentCreateFlowModal from '../assessments/AssessmentCreateFlowModal';
import http from '../../lib/http';

const ExternalAssessmentCreate = () => {
  const { code } = useParams();
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');
  const [ready, setReady] = useState(false);

  const normalizedCode = useMemo(() => (code || '').trim(), [code]);

  useEffect(() => {
    // Scope the header to this page only.
    const prev = axios.defaults.headers.common['x-external-create-code'];
    const prevHttp = http.defaults.headers.common['x-external-create-code'];
    if (normalizedCode) {
      axios.defaults.headers.common['x-external-create-code'] = normalizedCode;
      http.defaults.headers.common['x-external-create-code'] = normalizedCode;
      setReady(true);
    }
    return () => {
      if (prev) axios.defaults.headers.common['x-external-create-code'] = prev;
      else delete axios.defaults.headers.common['x-external-create-code'];

      if (prevHttp) http.defaults.headers.common['x-external-create-code'] = prevHttp;
      else delete http.defaults.headers.common['x-external-create-code'];
    };
  }, [normalizedCode]);

  if (!normalizedCode) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100/50 flex items-center justify-center p-6">
        <div className="bg-white border border-gray-200 rounded-2xl shadow-xl p-6 max-w-lg w-full">
          <p className="text-sm text-gray-700">Invalid link.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100/50">
      <div className="fixed inset-0 z-[200] flex items-center justify-center px-4 bg-black/50">
        <div
          className="relative flex flex-col w-full max-w-4xl h-[70vh] max-h-[80vh] bg-white rounded-2xl shadow-2xl overflow-hidden"
          style={{ minHeight: '580px' }}
          role="dialog"
          aria-modal="true"
        >
          {done ? (
            <div className="flex-1 flex items-center justify-center p-6" data-testid="success-toast">
              <div className="text-center max-w-md">
                <div className="mx-auto w-12 h-12 rounded-full bg-emerald-50 flex items-center justify-center">
                  <CheckCircleIcon className="w-7 h-7 text-emerald-600" />
                </div>
                <h2 className="mt-4 text-lg font-semibold text-gray-900">Assessment created</h2>
                <p className="mt-1 text-sm text-gray-600">
                  You can close this tab now.
                </p>
                {error && (
                  <p className="mt-3 text-xs text-rose-600">{error}</p>
                )}
              </div>
            </div>
          ) : ready ? (
            <AssessmentCreateFlowModal
              onClose={(result) => {
                // Library-only flow calls onClose({ savedToLibrary: true })
                if (result?.savedToLibrary) {
                  setDone(true);
                } else {
                  // If user closes early, still show completion-style page without implying saved.
                  setError('You closed the flow before saving.');
                  setDone(true);
                }
              }}
              skipInviteStep
              hasNextStep={false}
              hideExternalCreationLink
              forceShowVisibilityStep
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ExternalAssessmentCreate;

